// Digest: e38eba2b4e8f6eeb6f1e7f798d17ed1a020900df
/* eslint-disable */
/// <reference types="vite/client.d.ts" />/* eslint-disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export type ContainerSizeSubBlockOrNull = null | ContainerSizeSubBlock;
export type AlignedRichTextSubBlockOrNull = null | AlignedRichTextSubBlock;
export type RichTextBlockOrNull = null | RichTextBlock;
export type RichTextBlock = string;
export type _SlideListOrNull = null | _SlideList;
export type ImageChooserBlockOrNull = null | ImageChooserBlock;
export type _SlideList = _Slide[];
export type CharBlockOrNull = null | CharBlock;
export type CharBlock = string;
export type EmbedBlockOrNull = null | EmbedBlock;
export type EmbedBlock = string;
export type MediaChooserBlock = (
  | {
      type: "image";
      value: ImageChooserBlock;
      id: string;
    }
  | {
      type: "video";
      value: VideoChooserBlock;
      id: string;
    }
  | {
      type: "embed";
      value: MediaEmbedBlock;
      id: string;
    }
)[];
export type URLBlockOrNull = null | URLBlock;
export type URLBlock = string;
export type TableBlockOrNull = null | TableBlock;
export type TableBlock = string;
export type LabUIToolbox = (
  | {
      type: "alignedrichtextblock";
      value: AlignedRichTextBlock;
      id: string;
    }
  | {
      type: "gallerysubblock";
      value: GallerySubBlock;
      id: string;
    }
  | {
      type: "linksubblock";
      value: LinkSubBlock;
      id: string;
    }
  | {
      type: "mediachooserblock";
      value: MediaChooserBlock;
      id: string;
    }
  | {
      type: "scrollnavmenublock";
      value: ScrollNavMenuBlock;
      id: string;
    }
  | {
      type: "scrollnavmenuitemblock";
      value: ScrollNavMenuItemBlock;
      id: string;
    }
  | {
      type: "socialmediaicon";
      value: SocialMediaIcon;
      id: string;
    }
  | {
      type: "spacerblock";
      value: SpacerBlock;
      id: string;
    }
  | {
      type: "tableincontainerblock";
      value: TableInContainerBlock;
      id: string;
    }
  | {
      type: "onetrustprivacynoticeblock";
      value: OneTrustPrivacyNoticeBlock;
      id: string;
    }
  | {
      type: "videochooserblock";
      value: VideoChooserBlock;
      id: string;
    }
)[];
export type SimpleLinkBlockOrNull = null | SimpleLinkBlock;
export type MediaChooserBlockOrNull = null | MediaChooserBlock;
export type StaticBlockOrNull = null | StaticBlock;
export type GridItemBlockListOrNull = null | GridItemBlockList;
export type GridItemBlockList = GridItemBlock[];
export type HeroBlockListOrNull = null | HeroBlockList;
export type HeroBlockList = HeroBlock[];
export type SimpleLinkBlockListOrNull = null | SimpleLinkBlockList;
export type SimpleLinkBlockList = SimpleLinkBlock[];
export type LockedDownRichTextOrNull = null | LockedDownRichText;
export type LockedDownRichText = string;
export type VideoChooserBlockOrNull = null | VideoChooserBlock;
export type MediaChooserBlockListOrNull = null | MediaChooserBlockList;
export type MediaChooserBlockList = MediaChooserBlock[];
export type CategoryPageBlocks = (
  | {
      type: "animated_carousel";
      value: AnimatedCarousel;
      id: string;
    }
  | {
      type: "block_group";
      value: BlockGroup;
      id: string;
    }
  | {
      type: "centered_hero";
      value: CenteredHeroBlock;
      id: string;
    }
  | {
      type: "contact_subscribe";
      value: ContactSubscribeBlock;
      id: string;
    }
  | {
      type: "dual_image_split";
      value: DualImageSplitBlock;
      id: string;
    }
  | {
      type: "flipbook";
      value: FlipbookBlock;
      id: string;
    }
  | {
      type: "form";
      value: FormBlock;
      id: string;
    }
  | {
      type: "grid";
      value: GridBlock;
      id: string;
    }
  | {
      type: "image_background";
      value: ImageBackgroundBlock;
      id: string;
    }
  | {
      type: "image_background_carousel";
      value: ImageBackgroundCarouselBlock;
      id: string;
    }
  | {
      type: "image_text_slides";
      value: ImageTextSlidesBlock;
      id: string;
    }
  | {
      type: "locator_map";
      value: LocatorMapBlock;
      id: string;
    }
  | {
      type: "full_width";
      value: FullWidthImageBlock;
      id: string;
    }
  | {
      type: "modal_video_hero";
      value: ModalVideoHeroBlock;
      id: string;
    }
  | {
      type: "rich_text";
      value: SKSRichTextBlock;
      id: string;
    }
  | {
      type: "spacer";
      value: SpacerBlock;
      id: string;
    }
  | {
      type: "split";
      value: SplitBlock;
      id: string;
    }
  | {
      type: "split_form";
      value: SplitFormBlock;
      id: string;
    }
  | {
      type: "split_carousel";
      value: SplitCarouselBlock;
      id: string;
    }
  | {
      type: "page_children";
      value: ChildrenBlock;
      id: string;
    }
)[];
export type ValuePropSubBlockListOrNull = null | ValuePropSubBlockList;
export type ValuePropSubBlockList = ValuePropSubBlock[];
export type PageItemListOrNull = null | PageItemList;
export type PageItemList = PageItem[];
export type HomePageBlocks = (
  | {
      type: "animated_carousel";
      value: AnimatedCarousel;
      id: string;
    }
  | {
      type: "block_group";
      value: BlockGroup;
      id: string;
    }
  | {
      type: "centered_hero";
      value: CenteredHeroBlock;
      id: string;
    }
  | {
      type: "contact_subscribe";
      value: ContactSubscribeBlock;
      id: string;
    }
  | {
      type: "dual_image_split";
      value: DualImageSplitBlock;
      id: string;
    }
  | {
      type: "flipbook";
      value: FlipbookBlock;
      id: string;
    }
  | {
      type: "form";
      value: FormBlock;
      id: string;
    }
  | {
      type: "grid";
      value: GridBlock;
      id: string;
    }
  | {
      type: "image_background";
      value: ImageBackgroundBlock;
      id: string;
    }
  | {
      type: "image_background_carousel";
      value: ImageBackgroundCarouselBlock;
      id: string;
    }
  | {
      type: "image_text_slides";
      value: ImageTextSlidesBlock;
      id: string;
    }
  | {
      type: "locator_map";
      value: LocatorMapBlock;
      id: string;
    }
  | {
      type: "full_width";
      value: FullWidthImageBlock;
      id: string;
    }
  | {
      type: "modal_video_hero";
      value: ModalVideoHeroBlock;
      id: string;
    }
  | {
      type: "rich_text";
      value: SKSRichTextBlock;
      id: string;
    }
  | {
      type: "spacer";
      value: SpacerBlock;
      id: string;
    }
  | {
      type: "split";
      value: SplitBlock;
      id: string;
    }
  | {
      type: "split_form";
      value: SplitFormBlock;
      id: string;
    }
  | {
      type: "split_carousel";
      value: SplitCarouselBlock;
      id: string;
    }
  | {
      type: "promo";
      value: PromoBlock;
      id: string;
    }
  | {
      type: "split_with_value_props";
      value: SplitBlockWithValueProps;
      id: string;
    }
  | {
      type: "tabbed_block";
      value: TabbedBlock;
      id: string;
    }
)[];
export type ImageChooserBlockListOrNull = null | ImageChooserBlockList;
export type ImageChooserBlockList = ImageChooserBlock[];
export type SpecificationDetailBlockListOrNull = null | SpecificationDetailBlockList;
export type LockedDownRichTextListOrNull = null | LockedDownRichTextList;
export type LockedDownRichTextList = LockedDownRichText[];
export type SpecificationDetailBlockList = SpecificationDetailBlock[];
export type ProductPageBlocks = (
  | {
      type: "animated_carousel";
      value: AnimatedCarousel;
      id: string;
    }
  | {
      type: "block_group";
      value: BlockGroup;
      id: string;
    }
  | {
      type: "centered_hero";
      value: CenteredHeroBlock;
      id: string;
    }
  | {
      type: "contact_subscribe";
      value: ContactSubscribeBlock;
      id: string;
    }
  | {
      type: "dual_image_split";
      value: DualImageSplitBlock;
      id: string;
    }
  | {
      type: "flipbook";
      value: FlipbookBlock;
      id: string;
    }
  | {
      type: "form";
      value: FormBlock;
      id: string;
    }
  | {
      type: "grid";
      value: GridBlock;
      id: string;
    }
  | {
      type: "image_background";
      value: ImageBackgroundBlock;
      id: string;
    }
  | {
      type: "image_background_carousel";
      value: ImageBackgroundCarouselBlock;
      id: string;
    }
  | {
      type: "image_text_slides";
      value: ImageTextSlidesBlock;
      id: string;
    }
  | {
      type: "locator_map";
      value: LocatorMapBlock;
      id: string;
    }
  | {
      type: "full_width";
      value: FullWidthImageBlock;
      id: string;
    }
  | {
      type: "modal_video_hero";
      value: ModalVideoHeroBlock;
      id: string;
    }
  | {
      type: "rich_text";
      value: SKSRichTextBlock;
      id: string;
    }
  | {
      type: "spacer";
      value: SpacerBlock;
      id: string;
    }
  | {
      type: "split";
      value: SplitBlock;
      id: string;
    }
  | {
      type: "split_form";
      value: SplitFormBlock;
      id: string;
    }
  | {
      type: "split_carousel";
      value: SplitCarouselBlock;
      id: string;
    }
  | {
      type: "scroll_nav_menu";
      value: ScrollNavMenuBlock;
      id: string;
    }
  | {
      type: "scroll_nav_menu_item";
      value: ScrollNavMenuItemBlock;
      id: string;
    }
  | {
      type: "product_details";
      value: ProductDetailBlock;
      id: string;
    }
  | {
      type: "related_products";
      value: RelatedProductsBlock;
      id: string;
    }
  | {
      type: "request_quote";
      value: RequestQuoteBlock;
      id: string;
    }
)[];
export type DocumentChooserBlockOrNull = null | DocumentChooserBlock;
export type DownloadPageBlocks = (
  | {
      type: "animated_carousel";
      value: AnimatedCarousel;
      id: string;
    }
  | {
      type: "block_group";
      value: BlockGroup;
      id: string;
    }
  | {
      type: "centered_hero";
      value: CenteredHeroWithModalBlock;
      id: string;
    }
  | {
      type: "contact_subscribe";
      value: ContactSubscribeBlock;
      id: string;
    }
  | {
      type: "dual_image_split";
      value: DualImageSplitBlock;
      id: string;
    }
  | {
      type: "flipbook";
      value: FlipbookBlock;
      id: string;
    }
  | {
      type: "form";
      value: FormBlock;
      id: string;
    }
  | {
      type: "grid";
      value: GridBlock;
      id: string;
    }
  | {
      type: "image_background";
      value: ImageBackgroundBlock;
      id: string;
    }
  | {
      type: "image_background_carousel";
      value: ImageBackgroundCarouselBlock;
      id: string;
    }
  | {
      type: "image_text_slides";
      value: ImageTextSlidesBlock;
      id: string;
    }
  | {
      type: "locator_map";
      value: LocatorMapBlock;
      id: string;
    }
  | {
      type: "full_width";
      value: FullWidthImageBlock;
      id: string;
    }
  | {
      type: "modal_video_hero";
      value: ModalVideoHeroBlock;
      id: string;
    }
  | {
      type: "rich_text";
      value: SKSRichTextBlock;
      id: string;
    }
  | {
      type: "spacer";
      value: SpacerBlock;
      id: string;
    }
  | {
      type: "split";
      value: SplitBlock;
      id: string;
    }
  | {
      type: "split_form";
      value: SplitFormBlock;
      id: string;
    }
  | {
      type: "split_carousel";
      value: SplitCarouselBlock;
      id: string;
    }
  | {
      type: "download_library";
      value: DownloadLibraryBlock;
      id: string;
    }
)[];
export type SKSSocialMediaIconListOrNull = null | SKSSocialMediaIconList;
export type SKSSocialMediaIconList = SKSSocialMediaIcon[];
export type EventLandingPageBlocks = (
  | {
      type: "animated_carousel";
      value: AnimatedCarousel;
      id: string;
    }
  | {
      type: "block_group";
      value: BlockGroup;
      id: string;
    }
  | {
      type: "centered_hero";
      value: CenteredHeroBlock;
      id: string;
    }
  | {
      type: "contact_subscribe";
      value: ContactSubscribeBlock;
      id: string;
    }
  | {
      type: "dual_image_split";
      value: DualImageSplitBlock;
      id: string;
    }
  | {
      type: "flipbook";
      value: FlipbookBlock;
      id: string;
    }
  | {
      type: "form";
      value: FormBlock;
      id: string;
    }
  | {
      type: "grid";
      value: GridBlock;
      id: string;
    }
  | {
      type: "image_background";
      value: ImageBackgroundBlock;
      id: string;
    }
  | {
      type: "image_background_carousel";
      value: ImageBackgroundCarouselBlock;
      id: string;
    }
  | {
      type: "image_text_slides";
      value: ImageTextSlidesBlock;
      id: string;
    }
  | {
      type: "locator_map";
      value: LocatorMapBlock;
      id: string;
    }
  | {
      type: "full_width";
      value: FullWidthImageBlock;
      id: string;
    }
  | {
      type: "modal_video_hero";
      value: ModalVideoHeroBlock;
      id: string;
    }
  | {
      type: "rich_text";
      value: SKSRichTextBlock;
      id: string;
    }
  | {
      type: "spacer";
      value: SpacerBlock;
      id: string;
    }
  | {
      type: "split";
      value: SplitBlock;
      id: string;
    }
  | {
      type: "split_form";
      value: SplitFormBlock;
      id: string;
    }
  | {
      type: "split_carousel";
      value: SplitCarouselBlock;
      id: string;
    }
  | {
      type: "event_details";
      value: EventDetailsBlock;
      id: string;
    }
  | {
      type: "event_giveaway_form";
      value: EventGiveawayFormBlock;
      id: string;
    }
  | {
      type: "scroll_nav_menu_item";
      value: ScrollNavMenuItemBlock;
      id: string;
    }
)[];
export type RecipeMetadataEntryBlockList = RecipeMetadataEntryBlock[];
export type RecipeComponentIngredientsBlockList = RecipeComponentIngredientsBlock[];
export type RecipeHeaderBlock = (
  | {
      type: "metadata";
      value: RecipeMetadataEntryBlockList;
      id: string;
    }
  | {
      type: "components";
      value: RecipeComponentIngredientsBlockList;
      id: string;
    }
  | {
      type: "note";
      value: RichTextBlock;
      id: string;
    }
)[];
export type RecipePageBody = (
  | {
      type: "animated_carousel";
      value: AnimatedCarousel;
      id: string;
    }
  | {
      type: "block_group";
      value: BlockGroup;
      id: string;
    }
  | {
      type: "centered_hero";
      value: CenteredHeroBlock;
      id: string;
    }
  | {
      type: "contact_subscribe";
      value: ContactSubscribeBlock;
      id: string;
    }
  | {
      type: "dual_image_split";
      value: DualImageSplitBlock;
      id: string;
    }
  | {
      type: "flipbook";
      value: FlipbookBlock;
      id: string;
    }
  | {
      type: "form";
      value: FormBlock;
      id: string;
    }
  | {
      type: "grid";
      value: GridBlock;
      id: string;
    }
  | {
      type: "image_background";
      value: ImageBackgroundBlock;
      id: string;
    }
  | {
      type: "image_background_carousel";
      value: ImageBackgroundCarouselBlock;
      id: string;
    }
  | {
      type: "image_text_slides";
      value: ImageTextSlidesBlock;
      id: string;
    }
  | {
      type: "locator_map";
      value: LocatorMapBlock;
      id: string;
    }
  | {
      type: "full_width";
      value: FullWidthImageBlock;
      id: string;
    }
  | {
      type: "modal_video_hero";
      value: ModalVideoHeroBlock;
      id: string;
    }
  | {
      type: "rich_text";
      value: SKSRichTextBlock;
      id: string;
    }
  | {
      type: "spacer";
      value: SpacerBlock;
      id: string;
    }
  | {
      type: "split";
      value: SplitBlock;
      id: string;
    }
  | {
      type: "split_form";
      value: SplitFormBlock;
      id: string;
    }
  | {
      type: "split_carousel";
      value: SplitCarouselBlock;
      id: string;
    }
  | {
      type: "header";
      value: RecipeHeaderBlock;
      id: string;
    }
  | {
      type: "instructions";
      value: RichTextBlock;
      id: string;
    }
  | {
      type: "attribution";
      value: RichTextBlock;
      id: string;
    }
)[];
export type Toolbox = (
  | {
      type: "animated_carousel";
      value: AnimatedCarousel;
      id: string;
    }
  | {
      type: "block_group";
      value: BlockGroup;
      id: string;
    }
  | {
      type: "centered_hero";
      value: CenteredHeroBlock;
      id: string;
    }
  | {
      type: "contact_subscribe";
      value: ContactSubscribeBlock;
      id: string;
    }
  | {
      type: "dual_image_split";
      value: DualImageSplitBlock;
      id: string;
    }
  | {
      type: "flipbook";
      value: FlipbookBlock;
      id: string;
    }
  | {
      type: "form";
      value: FormBlock;
      id: string;
    }
  | {
      type: "grid";
      value: GridBlock;
      id: string;
    }
  | {
      type: "image_background";
      value: ImageBackgroundBlock;
      id: string;
    }
  | {
      type: "image_background_carousel";
      value: ImageBackgroundCarouselBlock;
      id: string;
    }
  | {
      type: "image_text_slides";
      value: ImageTextSlidesBlock;
      id: string;
    }
  | {
      type: "locator_map";
      value: LocatorMapBlock;
      id: string;
    }
  | {
      type: "full_width";
      value: FullWidthImageBlock;
      id: string;
    }
  | {
      type: "modal_video_hero";
      value: ModalVideoHeroBlock;
      id: string;
    }
  | {
      type: "rich_text";
      value: SKSRichTextBlock;
      id: string;
    }
  | {
      type: "spacer";
      value: SpacerBlock;
      id: string;
    }
  | {
      type: "split";
      value: SplitBlock;
      id: string;
    }
  | {
      type: "split_form";
      value: SplitFormBlock;
      id: string;
    }
  | {
      type: "split_carousel";
      value: SplitCarouselBlock;
      id: string;
    }
)[];
export type MetaTagsBlock = (
  | {
      type: "domain_verification";
      value: DomainVerificationBlock;
      id: string;
    }
  | {
      type: "ga4";
      value: GoogleAnalyticsFour;
      id: string;
    }
  | {
      type: "gtm";
      value: GoogleTagManagerBlock;
      id: string;
    }
  | {
      type: "onetrust_cookie_settings";
      value: OneTrustCookieSettingsBlock;
      id: string;
    }
)[];
export type FooterLinksColumnList = FooterLinksColumn[];
export type BooleanBlockOrNull = null | BooleanBlock;
export type BooleanBlock = boolean;
export type FooterNavigationBlock = (
  | {
      type: "columns";
      value: FooterLinksColumnList;
      id: string;
    }
  | {
      type: "social_media";
      value: FooterSocialMediaBlock;
      id: string;
    }
  | {
      type: "legal";
      value: FooterLegalText;
      id: string;
    }
)[];

export interface _Types {
  BasePageTemplateProps: ThelabuiModelsPagesBasePageBasePageTemplate;
  BaseFormPageTemplateProps: ThelabuiModelsPagesBaseFormPageBaseFormPageTemplate;
  BaseFormPageLandingPageTemplateProps: ThelabuiModelsPagesBaseFormPageBaseFormPageLandingPageTemplate;
  ExamplePageTemplateProps: ThelabuiModelsPagesExamplePageExamplePageTemplate;
  LabUIToolboxSnippetPreviewProps: ThelabuiModelsSnippetsToolboxSnippetLabUIToolboxSnippetPreview;
  PageAdCTAProps: ServerCmsTypesPageAdCTA;
  PageAdProps: ServerCmsTypesPageAd;
  SimpleLinkBlockProps: ServerCmsTypesSimpleLinkBlock;
  NavAdProps: ServerCmsTypesNavAd;
  SearchResultBadgeProps: ServerCmsTypesSearchResultBadge;
  RelatedProductProps: ServerCmsTypesRelatedProduct;
  CategoryPageTemplateProps: ServerCmsModelsPagesCategoryPageCategoryPageTemplate;
  HomePageTemplateProps: ServerCmsModelsPagesHomePageHomePageTemplate;
  ProductPageTemplateProps: ServerCmsModelsPagesProductPageProductPageTemplate;
  DownloadLibraryPageRootTemplateProps: ServerCmsModelsPagesDownloadLibraryPageDownloadLibraryPageRootTemplate;
  DownloadLibraryPageProductsTemplateProps: ServerCmsModelsPagesDownloadLibraryPageDownloadLibraryPageProductsTemplate;
  DownloadLibraryPageProductTemplateProps: ServerCmsModelsPagesDownloadLibraryPageDownloadLibraryPageProductTemplate;
  EventLandingPageTemplateProps: ServerCmsModelsPagesEventLandingPageEventLandingPageTemplate;
  PressReleasePageTemplateProps: ServerCmsModelsPagesPressReleasePagePressReleasePageTemplate;
  PressReleaseIndexPageTemplateProps: ServerCmsModelsPagesPressReleaseIndexPagePressReleaseIndexPageTemplate;
  RecipePageTemplateProps: ServerCmsModelsPagesRecipePageRecipePageTemplate;
  UtilityPageTemplateProps: ServerCmsModelsPagesUtilityPageUtilityPageTemplate;
  SearchResultsTemplateProps: ServerCmsTemplatesSearchResultsTemplate;
  globals: {
    Widget: generated.Types["Widget"];
    models: {
      "cms.models.pages.press_release_index_page.PressReleaseTile": CmsModelsPagesPressReleaseIndexPagePressReleaseTile;
      "cms.templates.SearchResult": CmsTemplatesSearchResult;
    };
  };
  Context: ReactivatedSerializationContextProcessorsBaseContext &
    ReactivatedSerializationContextProcessorsMessagesProcessor &
    ReactivatedSerializationContextProcessorsCSRFProcessor &
    ReactivatedSerializationContextProcessorsRequestProcessor &
    ReactivatedSerializationContextProcessorsStaticProcessor &
    ThelabuiContextProcessorsTranslationProcessor &
    ThelabuiContextProcessorsMetaTagsProcessor &
    ServerCmsContextProcessorsCoreAssetProcessor &
    ServerCmsContextProcessorsSettingsProcessor &
    ServerCmsContextProcessorsNavigationProcessor &
    ServerCmsContextProcessorsGeolocationProcessor;
  RPCPermission: null;
}
export interface ThelabuiModelsPagesBasePageBasePageTemplate {
  is_preview: boolean;
  page: BasePageEb66F00405;
}
export interface BasePageEb66F00405 {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  language: ThelabuiTypesLanguage | null;
  alternate_pages: ThelabuiTypesAlternatePage[];
}
export interface ThelabuiTypesLanguage {
  code: string;
  vernacular_name: string;
  translated_name: string;
  dir: "ltr" | "rtl" | "auto";
}
export interface ThelabuiTypesAlternatePage {
  title: string;
  url: string;
  language: ThelabuiTypesLanguage;
}
export interface ThelabuiModelsPagesBaseFormPageBaseFormPageTemplate {
  is_preview: boolean;
  page: BaseFormPageFe4F84D43A;
  form: DjangoFormsForms;
}
export interface BaseFormPageFe4F84D43A {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  language: ThelabuiTypesLanguage | null;
  alternate_pages: ThelabuiTypesAlternatePage[];
}
export interface DjangoFormsForms {
  name: "django.forms.forms.Form";
  errors: {} | null;
  fields: {};
  prefix: string;
  iterator: [];
  hidden_fields?: [];
}
export interface ThelabuiModelsPagesBaseFormPageBaseFormPageLandingPageTemplate {
  is_preview: boolean;
  page: BaseFormPageFe4F84D43A;
}
export interface ThelabuiModelsPagesExamplePageExamplePageTemplate {
  is_preview: boolean;
  page: ExamplePage_8C9639Cb8F;
}
export interface ExamplePage_8C9639Cb8F {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  language: ThelabuiTypesLanguage | null;
  alternate_pages: ThelabuiTypesAlternatePage[];
  image: {
    block: ThelabuiSerializationImagesImageBlockValue;
  } | null;
  image_tile: {
    renditions_webp: WagtailImageRendition[];
  } | null;
  richtext: RichTextField;
  body: ThelabuiExamplePage;
  snippets: {
    body: ThelabuiLabUIToolboxSnippet;
  }[];
  attachment: {
    title: string;
    created_at: string;
    file_size: number | null;
    file_hash: string;
    filename: string;
    file_extension: string;
    url: string;
    content_type: string;
    content_disposition: string;
    file: FileField;
    tags: {
      name: string;
    }[];
  } | null;
}
export interface ThelabuiSerializationImagesImageBlockValue {
  title: string;
  width: number;
  height: number;
  brightness: number | null;
  url: string;
  renditions: {
    [k: string]: ThelabuiSerializationImagesImageRenditionBlockValue;
  };
  imageData: string | null;
}
export interface ThelabuiSerializationImagesImageRenditionBlockValue {
  spec: string;
  width: number;
  height: number;
  url: string;
  size: number;
  mimetype: string;
}
export interface WagtailImageRendition {
  spec: string;
  width: number;
  height: number;
  url: string;
  size: number;
  mimetype: string;
}
export interface RichTextField {
  _type: "RichTextField";
  html: string;
}
export interface ThelabuiExamplePage {
  _type: "StreamField";
  _variant: "thelabui.ExamplePage.body";
  value: LabUIToolbox;
  [k: string]: unknown;
}
export interface AlignedRichTextBlock {
  container?: ContainerSizeSubBlockOrNull;
  content?: AlignedRichTextSubBlockOrNull;
}
export interface ContainerSizeSubBlock {
  width?: null | ("" | "full" | "twoThirds" | "half");
}
export interface AlignedRichTextSubBlock {
  content?: RichTextBlockOrNull;
  alignment?: null | ("" | "textAlignCenter" | "textAlignRight");
}
export interface GallerySubBlock {
  slides?: _SlideListOrNull;
}
export interface _Slide {
  image: ImageChooserBlockOrNull;
  caption?: AlignedRichTextSubBlockOrNull;
}
export interface ImageChooserBlock {
  title: string;
  width: number;
  height: number;
  brightness: null | number;
  url: string;
  renditions: {
    /**
     * This interface was referenced by `undefined`'s JSON-Schema definition
     * via the `patternProperty` "^.*$".
     */
    [k: string]: {
      spec: string;
      width: number;
      height: number;
      url: string;
      size: number;
      mimetype: string;
    };
  };
  imageData: null | string;
}
export interface LinkSubBlock {
  display_name?: CharBlockOrNull;
  link_type?: null | ("page" | "external" | "email" | "document");
  anchor?: CharBlockOrNull;
  link_style?: null | ("" | "secondary" | "text-link");
  url: null | string;
}
export interface VideoChooserBlock {
  poster: null | string;
  sources: {
    url: string;
    mimetype: string;
  }[];
  title: string;
  tracks: {
    kind: string;
    kind_name: string;
    src: string;
    label: string;
    srclang: string;
    srclang_name: null | string;
    sort_order: number;
  }[];
  width: null | number;
  height: null | number;
  aspectRatio: null | number;
}
export interface MediaEmbedBlock {
  title: CharBlockOrNull;
  thumbnail: ImageChooserBlockOrNull;
  embed: EmbedBlockOrNull;
}
export interface ScrollNavMenuBlock {}
export interface ScrollNavMenuItemBlock {
  name: CharBlockOrNull;
}
export interface SocialMediaIcon {
  icon: null | ("facebook" | "instagram" | "linkedin" | "pinterest" | "tiktok" | "twitter" | "youtube");
  link: URLBlockOrNull;
}
export interface SpacerBlock {
  anchor?: CharBlockOrNull;
  height: null | ("no-height" | "small" | "medium" | "large" | "xlarge" | "xxlarge" | "nano" | "micro" | "xxxlarge");
}
export interface TableInContainerBlock {
  container?: ContainerSizeSubBlockOrNull;
  table: TableBlockOrNull;
}
export interface OneTrustPrivacyNoticeBlock {
  script_url: URLBlockOrNull;
  callback_url: URLBlockOrNull;
  notice_url: URLBlockOrNull;
}
export interface ThelabuiLabUIToolboxSnippet {
  _type: "StreamField";
  _variant: "thelabui.LabUIToolboxSnippet.body";
  value: LabUIToolbox;
  [k: string]: unknown;
}
export interface FileField {
  url: string;
}
export interface ThelabuiModelsSnippetsToolboxSnippetLabUIToolboxSnippetPreview {
  object: LabUIToolboxSnippetFdc2906E1B;
}
export interface LabUIToolboxSnippetFdc2906E1B {
  id: number;
  name: string;
  body: ThelabuiLabUIToolboxSnippet;
}
export interface ServerCmsTypesPageAdCTA {
  text: string;
  url: string;
}
export interface ServerCmsTypesPageAd {
  subtitle: string | null;
  title: string;
  description: RichTextField;
  cta: ServerCmsTypesPageAdCTA;
  image: ThelabuiSerializationImagesImageBlockValue1 | null;
  image_mode: string;
  layout: string;
}
export interface ThelabuiSerializationImagesImageBlockValue1 {
  title: string;
  width: number;
  height: number;
  brightness: number | null;
  url: string;
  renditions: {
    [k: string]: ThelabuiSerializationImagesImageRenditionBlockValue;
  };
  imageData: string | null;
}
export interface ServerCmsTypesSimpleLinkBlock {
  display_name: string | null;
  link_type: string | null;
  anchor: string | null;
  url: string | null;
}
export interface ServerCmsTypesNavAd {
  title: string;
  description: string | null;
  image: ThelabuiSerializationImagesImageBlockValue1;
  cta: ServerCmsTypesSimpleLinkBlock;
}
export interface ServerCmsTypesSearchResultBadge {
  location: string;
  text: string;
}
export interface ServerCmsTypesRelatedProduct {
  id: number;
  url: string;
  title: string;
  sku: string;
  image: ThelabuiSerializationImagesImageBlockValue1 | null;
}
export interface ServerCmsModelsPagesCategoryPageCategoryPageTemplate {
  is_preview: boolean;
  page: CategoryPage_207Ad7C197;
}
export interface CategoryPage_207Ad7C197 {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  language: ThelabuiTypesLanguage | null;
  alternate_pages: ThelabuiTypesAlternatePage[];
  children: ServerCmsTypesPageAd[];
  body: CmsCategoryPage;
}
export interface CmsCategoryPage {
  _type: "StreamField";
  _variant: "cms.CategoryPage.body";
  value: CategoryPageBlocks;
  [k: string]: unknown;
}
export interface AnimatedCarousel {
  slides:
    | null
    | {
        type: "slide";
        value: ImageSlide;
        id: string;
      }[];
}
export interface ImageSlide {
  image: ImageChooserBlockOrNull;
}
export interface BlockGroup {
  background_color: null | ("transparent" | "white" | "black");
  items:
    | null
    | (
        | {
            type: "image_text_slides";
            value: ImageTextSlidesBlock;
            id: string;
          }
        | {
            type: "rich_text";
            value: SKSRichTextBlock;
            id: string;
          }
        | {
            type: "spacer";
            value: SpacerBlock;
            id: string;
          }
      )[];
}
export interface ImageTextSlidesBlock {
  slides:
    | null
    | {
        type: "slide";
        value: ImageTextSlide;
        id: string;
      }[];
}
export interface ImageTextSlide {
  image: ImageChooserBlockOrNull;
  url?: SimpleLinkBlockOrNull;
}
export interface SimpleLinkBlock {
  display_name?: CharBlockOrNull;
  link_type?: null | ("page" | "external" | "email" | "document");
  anchor?: CharBlockOrNull;
  url: null | string;
}
export interface SKSRichTextBlock {
  content: RichTextBlockOrNull;
  content_width: null | ("half" | "twoThirds" | "full");
  text_alignment: null | ("left" | "center");
}
export interface CenteredHeroBlock {
  content: RichTextBlockOrNull;
  media?: MediaChooserBlockOrNull;
  height: null | ("standard" | "compact" | "xlarge");
}
export interface ContactSubscribeBlock {
  formText?: RichTextBlockOrNull;
  contactText?: RichTextBlockOrNull;
  contactLink?: CharBlockOrNull;
  contactLinkText?: CharBlockOrNull;
  phone_national?: CharBlockOrNull;
  phone_e164?: CharBlockOrNull;
  locale?: string;
  legalText?: CharBlockOrNull;
}
export interface DualImageSplitBlock {
  content?: RichTextBlockOrNull;
  media: MediaChooserBlockOrNull;
  background_media: MediaChooserBlockOrNull;
  content_alignment: null | ("left" | "right");
}
export interface FlipbookBlock {
  note?: StaticBlockOrNull;
  url: URLBlockOrNull;
}
export interface StaticBlock {}
export interface FormBlock {
  form:
    | null
    | (
        | "contact"
        | "request-a-quote"
        | "stay-informed"
        | "design-guide-request-opt-in"
        | "lg-builder-registration"
        | "connect-with-dealer"
        | "event-giveaway"
        | "sf-giants"
        | "local-rep-contact"
      );
  custom_submit_url?: URLBlockOrNull;
}
export interface GridBlock {
  columns: null | ("two" | "three");
  items?: GridItemBlockListOrNull;
}
export interface GridItemBlock {
  image?: ImageChooserBlockOrNull;
  link?: SimpleLinkBlockOrNull;
  content?: RichTextBlockOrNull;
}
export interface ImageBackgroundBlock {
  content: RichTextBlockOrNull;
  media: MediaChooserBlockOrNull;
  content_alignment: null | ("left" | "right" | "bottom");
}
export interface ImageBackgroundCarouselBlock {
  title: CharBlockOrNull;
  slides?: HeroBlockListOrNull;
}
export interface HeroBlock {
  content: RichTextBlockOrNull;
  media: MediaChooserBlockOrNull;
}
export interface LocatorMapBlock {
  links?: SimpleLinkBlockListOrNull;
  map_type: null | ("DEALER" | "SERVICE");
}
export interface FullWidthImageBlock {
  media: MediaChooserBlockOrNull;
  container_width: null | ("full" | "container");
  video_type: null | ("background" | "foreground");
}
export interface ModalVideoHeroBlock {
  content: LockedDownRichTextOrNull;
  cta_text?: CharBlockOrNull;
  background_video: VideoChooserBlockOrNull;
  modal_video: VideoChooserBlockOrNull;
  content_alignment: null | ("center" | "bottom-center");
}
export interface SplitBlock {
  content: RichTextBlockOrNull;
  media: MediaChooserBlockOrNull;
  content_alignment: null | ("left" | "right");
  image_width: null | ("half" | "two-thirds");
}
export interface SplitFormBlock {
  content: RichTextBlockOrNull;
  media: MediaChooserBlockOrNull;
  content_alignment: null | ("left" | "right");
  image_width: null | ("half" | "two-thirds");
  form:
    | null
    | (
        | "contact"
        | "request-a-quote"
        | "stay-informed"
        | "design-guide-request-opt-in"
        | "lg-builder-registration"
        | "connect-with-dealer"
        | "event-giveaway"
        | "sf-giants"
        | "local-rep-contact"
      );
  custom_submit_url?: URLBlockOrNull;
  terms?: RichTextBlockOrNull;
  success_text?: RichTextBlockOrNull;
}
export interface SplitCarouselBlock {
  content: RichTextBlockOrNull;
  media?: MediaChooserBlockListOrNull;
  content_alignment: null | ("left" | "right");
  image_width: null | ("half" | "two-thirds");
}
export interface ChildrenBlock {}
export interface ServerCmsModelsPagesHomePageHomePageTemplate {
  is_preview: boolean;
  page: HomePage_1Cd209C97F;
}
export interface HomePage_1Cd209C97F {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  language: ThelabuiTypesLanguage | null;
  alternate_pages: ThelabuiTypesAlternatePage[];
  body: CmsHomePage;
}
export interface CmsHomePage {
  _type: "StreamField";
  _variant: "cms.HomePage.body";
  value: HomePageBlocks;
  [k: string]: unknown;
}
export interface PromoBlock {
  content: RichTextBlockOrNull;
  media?: MediaChooserBlockOrNull;
  height: null | ("standard" | "compact" | "xlarge");
}
export interface SplitBlockWithValueProps {
  content: RichTextBlockOrNull;
  media: MediaChooserBlockOrNull;
  content_alignment: null | ("left" | "right");
  value_props?: ValuePropSubBlockListOrNull;
}
export interface ValuePropSubBlock {
  image: ImageChooserBlockOrNull;
  text: CharBlockOrNull;
}
export interface TabbedBlock {
  title: CharBlockOrNull;
  tabs:
    | null
    | (
        | {
            type: "page_list_tab";
            value: PageListTab;
            id: string;
          }
        | {
            type: "content_tab";
            value: ContentTab;
            id: string;
          }
      )[];
}
export interface PageListTab {
  tab_label: CharBlockOrNull;
  pages?: PageItemListOrNull;
  cta?: SimpleLinkBlockOrNull;
}
export interface PageItem {
  link?: SimpleLinkBlockOrNull;
  image: ImageChooserBlockOrNull;
  cta_text?: CharBlockOrNull;
}
export interface ContentTab {
  tab_label: CharBlockOrNull;
  content: RichTextBlockOrNull;
  image: ImageChooserBlockOrNull;
}
export interface ServerCmsModelsPagesProductPageProductPageTemplate {
  is_preview: boolean;
  page: ProductPageE592C2B0A4;
}
export interface ProductPageE592C2B0A4 {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  language: ThelabuiTypesLanguage | null;
  alternate_pages: ThelabuiTypesAlternatePage[];
  locale: {
    language_code: string;
  };
  product: {
    sku: string;
  };
  documents: ServerCmsModelsSnippetsProductProductDocument[];
  msrp: Money | null;
  body: CmsProductPage;
  downloadlib_tile_image: {
    file: FileField;
  } | null;
  related_products: ServerCmsTypesRelatedProduct[];
}
export interface ServerCmsModelsSnippetsProductProductDocument {
  id: number;
  doc_type: DocumentType_716F65De42;
  file: Document_6Eff0Eeccb;
}
export interface DocumentType_716F65De42 {
  category: {
    id: number;
    name: string;
    sort_order: number;
  };
  id: number;
  name: string;
  sort_order: number | null;
}
export interface Document_6Eff0Eeccb {
  id: number;
  url: string;
}
export interface Money {
  currency: Currency;
  amount: string;
  decimal_places: number;
  formatted: string;
}
export interface Currency {
  code: string;
  iso_4217_code: string;
  sub_unit: number;
  name: string;
}
export interface CmsProductPage {
  _type: "StreamField";
  _variant: "cms.ProductPage.body";
  value: ProductPageBlocks;
  [k: string]: unknown;
}
export interface ProductDetailBlock {
  images?: ImageChooserBlockListOrNull;
  specification_details?: SpecificationDetailBlockListOrNull;
}
export interface SpecificationDetailBlock {
  section:
    | null
    | (
        | "innovation"
        | "generalDimensions"
        | "netWeight"
        | "warranty"
        | "includedAccessories"
        | "optionalAccessories"
        | "performance"
        | "capacityAndStorage"
      );
  items?: LockedDownRichTextListOrNull;
}
export interface RelatedProductsBlock {
  note?: StaticBlockOrNull;
}
export interface RequestQuoteBlock {
  note?: StaticBlockOrNull;
}
export interface ServerCmsModelsPagesDownloadLibraryPageDownloadLibraryPageRootTemplate {
  is_preview: boolean;
  page: DownloadLibraryPageD5172Fcc39;
  autocomplete: ServerCmsModelsPagesDownloadLibraryPageAutocompleteEntry[];
  breadcrumbs: ServerCmsModelsPagesDownloadLibraryPageBreadcrumb[];
  categories: ServerCmsModelsPagesMixinsDownloadLibraryTile[];
}
export interface DownloadLibraryPageD5172Fcc39 {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  language: ThelabuiTypesLanguage | null;
  alternate_pages: ThelabuiTypesAlternatePage[];
  body: CmsDownloadLibraryPage;
}
export interface CmsDownloadLibraryPage {
  _type: "StreamField";
  _variant: "cms.DownloadLibraryPage.body";
  value: DownloadPageBlocks;
  [k: string]: unknown;
}
export interface CenteredHeroWithModalBlock {
  content: RichTextBlockOrNull;
  media?: MediaChooserBlockOrNull;
  height: null | ("standard" | "compact" | "xlarge");
  form_content: RichTextBlockOrNull;
  design_guide: DocumentChooserBlockOrNull;
  success_content: RichTextBlockOrNull;
}
export interface DocumentChooserBlock {
  title: string;
  url: string;
  mimetype: string;
}
export interface DownloadLibraryBlock {}
export interface ServerCmsModelsPagesDownloadLibraryPageAutocompleteEntry {
  title: string;
  sku: string;
  url: string;
}
export interface ServerCmsModelsPagesDownloadLibraryPageBreadcrumb {
  title: string;
  url: string | null;
}
export interface ServerCmsModelsPagesMixinsDownloadLibraryTile {
  id: number;
  depth: number;
  path: string;
  url: string;
  image: ThelabuiSerializationImagesImageBlockValue1 | null;
  title: string;
  description: string;
  eyebrow: string | null;
  documents: ServerCmsModelsSnippetsProductProductDocument[];
}
export interface ServerCmsModelsPagesDownloadLibraryPageDownloadLibraryPageProductsTemplate {
  is_preview: boolean;
  page: DownloadLibraryPageD5172Fcc39;
  autocomplete: ServerCmsModelsPagesDownloadLibraryPageAutocompleteEntry[];
  breadcrumbs: ServerCmsModelsPagesDownloadLibraryPageBreadcrumb[];
  category: ServerCmsModelsPagesMixinsDownloadLibraryTile;
  products: ServerCmsModelsPagesMixinsDownloadLibraryTile[];
}
export interface ServerCmsModelsPagesDownloadLibraryPageDownloadLibraryPageProductTemplate {
  is_preview: boolean;
  page: DownloadLibraryPageD5172Fcc39;
  autocomplete: ServerCmsModelsPagesDownloadLibraryPageAutocompleteEntry[];
  breadcrumbs: ServerCmsModelsPagesDownloadLibraryPageBreadcrumb[];
  category: ServerCmsModelsPagesMixinsDownloadLibraryTile;
  product: ServerCmsModelsPagesMixinsDownloadLibraryTile;
}
export interface ServerCmsModelsPagesEventLandingPageEventLandingPageTemplate {
  is_preview: boolean;
  page: EventLandingPage_08064D5E3B;
}
export interface EventLandingPage_08064D5E3B {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  language: ThelabuiTypesLanguage | null;
  alternate_pages: ThelabuiTypesAlternatePage[];
  body: CmsEventLandingPage;
}
export interface CmsEventLandingPage {
  _type: "StreamField";
  _variant: "cms.EventLandingPage.body";
  value: EventLandingPageBlocks;
  [k: string]: unknown;
}
export interface EventDetailsBlock {
  content: RichTextBlockOrNull;
  media: MediaChooserBlockOrNull;
  content_alignment: null | ("left" | "right");
  image_width: null | ("half" | "two-thirds");
  image?: ImageChooserBlockOrNull;
  date?: CharBlockOrNull;
  location?: CharBlockOrNull;
  booth?: CharBlockOrNull;
  icons?: SKSSocialMediaIconListOrNull;
}
export interface SKSSocialMediaIcon {
  icon: null | ("facebook" | "instagram" | "linkedin" | "pinterest" | "tiktok" | "twitter" | "youtube" | "houzz");
  link: URLBlockOrNull;
}
export interface EventGiveawayFormBlock {
  content: RichTextBlockOrNull;
  media: MediaChooserBlockOrNull;
  content_alignment: null | ("left" | "right");
  image_width: null | ("half" | "two-thirds");
  terms?: RichTextBlockOrNull;
  success_text?: RichTextBlockOrNull;
}
export interface ServerCmsModelsPagesPressReleasePagePressReleasePageTemplate {
  is_preview: boolean;
  page: PressReleasePageAa6Ecaff6E;
}
export interface PressReleasePageAa6Ecaff6E {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  language: ThelabuiTypesLanguage | null;
  alternate_pages: ThelabuiTypesAlternatePage[];
  date: string;
  caption: RichTextField;
  body: RichTextField;
  contact_subscribe: ServerCmsModelsPagesPressReleasePageContactSubscribeInfo;
}
export interface ServerCmsModelsPagesPressReleasePageContactSubscribeInfo {
  formText: string | null;
  contactText: string | null;
  contactLink: string | null;
  contactLinkText: string | null;
  phone_national: string | null;
  phone_e164: string | null;
  legalText: string | null;
  locale: string;
}
export interface ServerCmsModelsPagesPressReleaseIndexPagePressReleaseIndexPageTemplate {
  is_preview: boolean;
  page: PressReleaseIndexPage_06B582D247;
}
export interface PressReleaseIndexPage_06B582D247 {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  language: ThelabuiTypesLanguage | null;
  alternate_pages: ThelabuiTypesAlternatePage[];
  url: string;
  articles: CmsModelsPagesPressReleaseIndexPagePressReleaseTile[];
  head_image: {
    block: ThelabuiSerializationImagesImageBlockValue2;
  } | null;
}
export interface CmsModelsPagesPressReleaseIndexPagePressReleaseTile {
  id: number;
  title: string;
  date: string;
  url: string;
}
export interface ThelabuiSerializationImagesImageBlockValue2 {
  title: string;
  width: number;
  height: number;
  brightness: number | null;
  url: string;
  renditions: {
    [k: string]: ThelabuiSerializationImagesImageRenditionBlockValue;
  };
  imageData: string | null;
}
export interface ServerCmsModelsPagesRecipePageRecipePageTemplate {
  is_preview: boolean;
  page: RecipePage_4C5F3738D2;
}
export interface RecipePage_4C5F3738D2 {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  language: ThelabuiTypesLanguage | null;
  alternate_pages: ThelabuiTypesAlternatePage[];
  hero: {
    block: ThelabuiSerializationImagesImageBlockValue3;
  } | null;
  body: CmsRecipePage;
}
export interface ThelabuiSerializationImagesImageBlockValue3 {
  title: string;
  width: number;
  height: number;
  brightness: number | null;
  url: string;
  renditions: {
    [k: string]: ThelabuiSerializationImagesImageRenditionBlockValue;
  };
  imageData: string | null;
}
export interface CmsRecipePage {
  _type: "StreamField";
  _variant: "cms.RecipePage.body";
  value: RecipePageBody;
  [k: string]: unknown;
}
export interface RecipeMetadataEntryBlock {
  type: null | ("" | "SERVINGS" | "PREPPING_TIME" | "COOKING_TIME");
  value: CharBlockOrNull;
  note?: CharBlockOrNull;
}
export interface RecipeComponentIngredientsBlock {
  component_name?: CharBlockOrNull;
  ingredients: RichTextBlockOrNull;
}
export interface ServerCmsModelsPagesUtilityPageUtilityPageTemplate {
  is_preview: boolean;
  page: UtilityPageCcfe026133;
}
export interface UtilityPageCcfe026133 {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  language: ThelabuiTypesLanguage | null;
  alternate_pages: ThelabuiTypesAlternatePage[];
  body: CmsUtilityPage;
}
export interface CmsUtilityPage {
  _type: "StreamField";
  _variant: "cms.UtilityPage.body";
  value: Toolbox;
  [k: string]: unknown;
}
export interface ServerCmsTemplatesSearchResultsTemplate {
  language: ThelabuiTypesLanguage;
  query: string;
  results: CmsTemplatesSearchResult[];
}
export interface CmsTemplatesSearchResult {
  id: number;
  url: string;
  title: string;
  search_description: string;
  search_image: ThelabuiSerializationImagesImageBlockValue1 | null;
  search_badges: ServerCmsTypesSearchResultBadge[];
}
export interface ReactivatedSerializationContextProcessorsBaseContext {
  template_name: string;
}
export interface ReactivatedSerializationContextProcessorsMessagesProcessor {
  messages: ReactivatedSerializationContextProcessorsMessage[];
}
export interface ReactivatedSerializationContextProcessorsMessage {
  level_tag: "info" | "success" | "error" | "warning" | "debug";
  message: string;
  level: number;
  from_server: boolean;
}
export interface ReactivatedSerializationContextProcessorsCSRFProcessor {
  csrf_token: string;
}
export interface ReactivatedSerializationContextProcessorsRequestProcessor {
  request: ReactivatedSerializationContextProcessorsRequest;
}
export interface ReactivatedSerializationContextProcessorsRequest {
  path: string;
  url: string;
  csp_nonce: string | null;
}
export interface ReactivatedSerializationContextProcessorsStaticProcessor {
  STATIC_URL: string;
}
export interface ThelabuiContextProcessorsTranslationProcessor {
  i18n: ThelabuiContextProcessorsTranslationCatalog;
}
export interface ThelabuiContextProcessorsTranslationCatalog {
  language: ThelabuiTypesLanguage;
  catalog: ThelabuiContextProcessorsCatalogEntry[];
  formats: ThelabuiContextProcessorsFormatEntry[];
}
export interface ThelabuiContextProcessorsCatalogEntry {
  key: string;
  value: string;
}
export interface ThelabuiContextProcessorsFormatEntry {
  key: string;
  value: string | number | string[];
}
export interface ThelabuiContextProcessorsMetaTagsProcessor {
  meta_tags: MetaTagSettings_3D1Fcbef23;
}
export interface MetaTagSettings_3D1Fcbef23 {
  meta_tags: ThelabuiMetaTagSettings;
}
export interface ThelabuiMetaTagSettings {
  _type: "StreamField";
  _variant: "thelabui.MetaTagSettings.meta_tags";
  value: MetaTagsBlock;
  [k: string]: unknown;
}
export interface DomainVerificationBlock {
  type: null | ("" | "google-site-verification" | "p:domain_verify" | "facebook-domain-verification");
  value: CharBlockOrNull;
}
export interface GoogleAnalyticsFour {
  container_id: CharBlockOrNull;
}
export interface GoogleTagManagerBlock {
  container_id: CharBlockOrNull;
}
export interface OneTrustCookieSettingsBlock {
  domain_script_uuid: CharBlockOrNull;
}
export interface ServerCmsContextProcessorsCoreAssetProcessor {
  core_assets: ServerCmsContextProcessorsCoreAssets;
}
export interface ServerCmsContextProcessorsCoreAssets {
  logo: string;
  logo_inverted: string;
  apple_touch_icon: string;
  favicon_png: string;
  favicon_ico: string;
  favicon_svg: string;
}
export interface ServerCmsContextProcessorsSettingsProcessor {
  LOCALE: string;
  SENTRY_DSN: string | null;
  CI_COMMIT_REF_SLUG: string;
  CI_COMMIT_SHA: string;
  GOOGLE_MAPS_V3_APIKEY: string | null;
  DISTANCE_UNIT: string;
  STATES: {
    [k: string]: string;
  };
  ENVIRONMENT: string;
}
export interface ServerCmsContextProcessorsNavigationProcessor {
  root_page: ServerCmsContextProcessorsSiteRootPage;
  nav: ServerCmsContextProcessorsNavigationItem[];
  footer: SiteFooterA9C495182B | null;
  countries: ServerCmsContextProcessorsCountryPage[];
  wagtail_links: ServerCmsContextProcessorsWagtailLinks;
}
export interface ServerCmsContextProcessorsSiteRootPage {
  title: string;
  seo_title: string;
  url: string;
}
export interface ServerCmsContextProcessorsNavigationItem {
  title: string;
  url: string;
  path: string;
  depth: number;
  nav_ads: ServerCmsTypesNavAd[];
}
export interface SiteFooterA9C495182B {
  body: CmsSiteFooter;
}
export interface CmsSiteFooter {
  _type: "StreamField";
  _variant: "cms.SiteFooter.body";
  value: FooterNavigationBlock;
  [k: string]: unknown;
}
export interface FooterLinksColumn {
  title: CharBlockOrNull;
  links?: SimpleLinkBlockListOrNull;
  width: null | ("small" | "regular" | "wide");
}
export interface FooterSocialMediaBlock {
  title: RichTextBlockOrNull;
  show_country_selector?: BooleanBlockOrNull;
  icons?: SKSSocialMediaIconListOrNull;
}
export interface FooterLegalText {
  copyright: RichTextBlockOrNull;
  links?: SimpleLinkBlockListOrNull;
  accessibility: RichTextBlockOrNull;
}
export interface ServerCmsContextProcessorsCountryPage {
  language_code: string;
  display_name: string;
  locale_autonym: string;
  url: string;
}
export interface ServerCmsContextProcessorsWagtailLinks {
  search: string;
  find_dealer: string;
  privacy_policy: string;
}
export interface ServerCmsContextProcessorsGeolocationProcessor {
  suggested_locale: string | null;
}
export class RPC {
    constructor(public requester: rpcUtils.Requester) {
    }
}
export type UUID = `${string}-${string}-${string}-${string}-${string}`;

import type {Renderer as GenericRenderer} from "reactivated/dist/render.mjs";
export type Renderer = GenericRenderer<_Types["Context"]>;

export const rpc = new RPC(typeof window != "undefined" ? rpcUtils.defaultRequester : null as any);
import React from "react"
import * as generated from "reactivated/dist/generated";
import * as rpcUtils from "reactivated/dist/rpc";
import {constants} from "./constants";
export {constants};

export function classNames(...classes: (string | undefined | null | false)[]) {
    return classes.filter(Boolean).join(" ");
}

// Note: this needs strict function types to behave correctly with excess properties etc.
export type Checker<P, U extends (React.FunctionComponent<P> | React.ComponentClass<P>)> = {};

export type Result<TSuccess, TInvalid> = rpcUtils.Result<TSuccess, TInvalid, _Types["RPCPermission"]>;

export {Context} from "./context";
import {Context} from "./context";

import * as forms from "reactivated/dist/forms";
export type {FormHandler} from "reactivated/dist/forms";
export {reverse} from "./urls";

export const Provider = (props: {value: _Types["Context"]; children: React.ReactNode}) => {
    const [value, setValue] = React.useState(props.value);

    return (
        <Context.Provider value={{...value, setValue}}>
            {props.children}
        </Context.Provider>
    );
};

export const getServerData = () => {
    const props: Record<string, unknown> = (window as any).__PRELOADED_PROPS__;
    const context: _Types["Context"] = (window as any).__PRELOADED_CONTEXT__;

    return {props, context};
};

export type models = _Types["globals"]["models"];

export type {FieldHandler} from "./forms";
export {Form, FormSet, Widget, useForm, useFormSet, ManagementForm} from "reactivated/dist/forms";


import {Template as BasePageTemplateImplementation} from "@client/templates/BasePageTemplate"
export type BasePageTemplateCheck = Checker<_Types["BasePageTemplateProps"], typeof BasePageTemplateImplementation>;

export namespace templates {
    export type BasePageTemplate = _Types["BasePageTemplateProps"];
}


        



import {Template as BaseFormPageTemplateImplementation} from "@client/templates/BaseFormPageTemplate"
export type BaseFormPageTemplateCheck = Checker<_Types["BaseFormPageTemplateProps"], typeof BaseFormPageTemplateImplementation>;

export namespace templates {
    export type BaseFormPageTemplate = _Types["BaseFormPageTemplateProps"];
}


        



import {Template as BaseFormPageLandingPageTemplateImplementation} from "@client/templates/BaseFormPageLandingPageTemplate"
export type BaseFormPageLandingPageTemplateCheck = Checker<_Types["BaseFormPageLandingPageTemplateProps"], typeof BaseFormPageLandingPageTemplateImplementation>;

export namespace templates {
    export type BaseFormPageLandingPageTemplate = _Types["BaseFormPageLandingPageTemplateProps"];
}


        



import {Template as ExamplePageTemplateImplementation} from "@client/templates/ExamplePageTemplate"
export type ExamplePageTemplateCheck = Checker<_Types["ExamplePageTemplateProps"], typeof ExamplePageTemplateImplementation>;

export namespace templates {
    export type ExamplePageTemplate = _Types["ExamplePageTemplateProps"];
}


        



import {Template as LabUIToolboxSnippetPreviewImplementation} from "@client/templates/LabUIToolboxSnippetPreview"
export type LabUIToolboxSnippetPreviewCheck = Checker<_Types["LabUIToolboxSnippetPreviewProps"], typeof LabUIToolboxSnippetPreviewImplementation>;

export namespace templates {
    export type LabUIToolboxSnippetPreview = _Types["LabUIToolboxSnippetPreviewProps"];
}


        



import {Template as CategoryPageTemplateImplementation} from "@client/templates/CategoryPageTemplate"
export type CategoryPageTemplateCheck = Checker<_Types["CategoryPageTemplateProps"], typeof CategoryPageTemplateImplementation>;

export namespace templates {
    export type CategoryPageTemplate = _Types["CategoryPageTemplateProps"];
}


        



import {Template as HomePageTemplateImplementation} from "@client/templates/HomePageTemplate"
export type HomePageTemplateCheck = Checker<_Types["HomePageTemplateProps"], typeof HomePageTemplateImplementation>;

export namespace templates {
    export type HomePageTemplate = _Types["HomePageTemplateProps"];
}


        



import {Template as ProductPageTemplateImplementation} from "@client/templates/ProductPageTemplate"
export type ProductPageTemplateCheck = Checker<_Types["ProductPageTemplateProps"], typeof ProductPageTemplateImplementation>;

export namespace templates {
    export type ProductPageTemplate = _Types["ProductPageTemplateProps"];
}


        



import {Template as DownloadLibraryPageRootTemplateImplementation} from "@client/templates/DownloadLibraryPageRootTemplate"
export type DownloadLibraryPageRootTemplateCheck = Checker<_Types["DownloadLibraryPageRootTemplateProps"], typeof DownloadLibraryPageRootTemplateImplementation>;

export namespace templates {
    export type DownloadLibraryPageRootTemplate = _Types["DownloadLibraryPageRootTemplateProps"];
}


        



import {Template as DownloadLibraryPageProductsTemplateImplementation} from "@client/templates/DownloadLibraryPageProductsTemplate"
export type DownloadLibraryPageProductsTemplateCheck = Checker<_Types["DownloadLibraryPageProductsTemplateProps"], typeof DownloadLibraryPageProductsTemplateImplementation>;

export namespace templates {
    export type DownloadLibraryPageProductsTemplate = _Types["DownloadLibraryPageProductsTemplateProps"];
}


        



import {Template as DownloadLibraryPageProductTemplateImplementation} from "@client/templates/DownloadLibraryPageProductTemplate"
export type DownloadLibraryPageProductTemplateCheck = Checker<_Types["DownloadLibraryPageProductTemplateProps"], typeof DownloadLibraryPageProductTemplateImplementation>;

export namespace templates {
    export type DownloadLibraryPageProductTemplate = _Types["DownloadLibraryPageProductTemplateProps"];
}


        



import {Template as EventLandingPageTemplateImplementation} from "@client/templates/EventLandingPageTemplate"
export type EventLandingPageTemplateCheck = Checker<_Types["EventLandingPageTemplateProps"], typeof EventLandingPageTemplateImplementation>;

export namespace templates {
    export type EventLandingPageTemplate = _Types["EventLandingPageTemplateProps"];
}


        



import {Template as PressReleasePageTemplateImplementation} from "@client/templates/PressReleasePageTemplate"
export type PressReleasePageTemplateCheck = Checker<_Types["PressReleasePageTemplateProps"], typeof PressReleasePageTemplateImplementation>;

export namespace templates {
    export type PressReleasePageTemplate = _Types["PressReleasePageTemplateProps"];
}


        



import {Template as PressReleaseIndexPageTemplateImplementation} from "@client/templates/PressReleaseIndexPageTemplate"
export type PressReleaseIndexPageTemplateCheck = Checker<_Types["PressReleaseIndexPageTemplateProps"], typeof PressReleaseIndexPageTemplateImplementation>;

export namespace templates {
    export type PressReleaseIndexPageTemplate = _Types["PressReleaseIndexPageTemplateProps"];
}


        



import {Template as RecipePageTemplateImplementation} from "@client/templates/RecipePageTemplate"
export type RecipePageTemplateCheck = Checker<_Types["RecipePageTemplateProps"], typeof RecipePageTemplateImplementation>;

export namespace templates {
    export type RecipePageTemplate = _Types["RecipePageTemplateProps"];
}


        



import {Template as UtilityPageTemplateImplementation} from "@client/templates/UtilityPageTemplate"
export type UtilityPageTemplateCheck = Checker<_Types["UtilityPageTemplateProps"], typeof UtilityPageTemplateImplementation>;

export namespace templates {
    export type UtilityPageTemplate = _Types["UtilityPageTemplateProps"];
}


        



import {Template as SearchResultsTemplateImplementation} from "@client/templates/SearchResultsTemplate"
export type SearchResultsTemplateCheck = Checker<_Types["SearchResultsTemplateProps"], typeof SearchResultsTemplateImplementation>;

export namespace templates {
    export type SearchResultsTemplate = _Types["SearchResultsTemplateProps"];
}


        



export namespace interfaces {
    export type PageAdCTA = _Types["PageAdCTAProps"];
}


        



export namespace interfaces {
    export type PageAd = _Types["PageAdProps"];
}


        



export namespace interfaces {
    export type SimpleLinkBlock = _Types["SimpleLinkBlockProps"];
}


        



export namespace interfaces {
    export type NavAd = _Types["NavAdProps"];
}


        



export namespace interfaces {
    export type SearchResultBadge = _Types["SearchResultBadgeProps"];
}


        



export namespace interfaces {
    export type RelatedProduct = _Types["RelatedProductProps"];
}


        
export {Iterator, CSRFToken, createRenderer} from "./forms";
export {getTemplate} from "./template";

